import { AxiosPromise } from 'axios';
import { EndPointService } from 'src/services/api-handlers/axios';

function getAdminWorks(params: any): AxiosPromise {
    return EndPointService.get('/admin_works', { params });
}

function getAdminWork(id: number | string): AxiosPromise {
    return EndPointService.get(`/admin_works/${id}`);
}

function deleteAdminWork(id: number | string): AxiosPromise {
    return EndPointService.delete(`/admin_works/${id}`);
}

function createAdminWork(payload: any): AxiosPromise {
    return EndPointService.post('/admin_works', payload);
}

function updateAdminWork(id: number | string, payload: any): AxiosPromise {
    return EndPointService.put(`/admin_works/${id}`, { ...payload });
}

export default {
    getAdminWorks,

    getAdminWork,
    deleteAdminWork,
    createAdminWork,
    updateAdminWork,
};
